
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitobanglorecab() {



    const cardData =
    {
        keyword: 'Mumbai to Bangalore Cab',
        heading: 'S9 Travels: Mumbai to Bangalore Cab',
        headingDescription: 'S9 Travels offers Mumbai to Bangalore Cab Service, ensuring a comfortable, reliable, and hassle-free long-distance journey. Whether you are traveling for business, leisure, or family trips, our Innova cabs provide a smooth and safe ride. With spacious interiors, luxury features, and professional drivers, we guarantee a stress-free travel experience. Enjoy on-time pickups, affordable pricing, and 24/7 service. Book your Mumbai to Bangalore cab with S9 Travels for a seamless and enjoyable road trip!',


        top: 'Top Places to Visit in Lonavala with S9 Travels',

"topPlaces": [
    {
      "title": "Bangalore Palace",
      "description": "A stunning palace inspired by England's Windsor Castle, Bangalore Palace offers a glimpse into the city's royal heritage with its grand architecture and lush gardens."
    },
    {
      "title": "Lalbagh Botanical Garden",
      "description": "A sprawling botanical garden featuring diverse plant species, a glasshouse inspired by London's Crystal Palace, and the iconic Lalbagh Rock, which is over 3,000 million years old."
    },
    {
      "title": "Cubbon Park",
      "description": "A green oasis in the heart of the city, Cubbon Park is perfect for nature lovers, joggers, and those looking to escape the city's hustle and bustle."
    },
    {
      "title": "ISKCON Temple Bangalore",
      "description": "One of the largest ISKCON temples in the world, this spiritual destination is dedicated to Lord Krishna and offers a peaceful ambiance and mesmerizing architecture."
    },
    {
      "title": "Bannerghatta National Park",
      "description": "A wildlife park on the outskirts of Bangalore, Bannerghatta National Park is home to a zoo, a butterfly park, and a safari that lets you spot tigers, lions, and elephants."
    },
    {
      "title": "Nandi Hills",
      "description": "A popular hill station near Bangalore, Nandi Hills is known for its breathtaking sunrise views, scenic landscapes, and historical forts."
    },
    {
      "title": "Wonderla Amusement Park",
      "description": "One of India's best amusement parks, Wonderla features thrilling rides, water slides, and entertainment for visitors of all ages."
    },
    {
      "title": "Vidhana Soudha",
      "description": "An architectural marvel and the seat of Karnataka's state legislature, Vidhana Soudha is a grand example of neo-Dravidian architecture."
    },
    {
      "title": "Ulsoor Lake",
      "description": "A serene and picturesque lake in Bangalore, Ulsoor Lake is a great spot for boating, birdwatching, and relaxing by the water."
    },
    {
      "title": "Commercial Street",
      "description": "A bustling shopping destination in Bangalore, Commercial Street is known for its variety of clothing, jewelry, and accessories at affordable prices."
    }
],

"services": [
    {
      "name": "Mumbai to Bangalore Cab Service",
      "description": "Travel comfortably from Mumbai to Bangalore with S9 Travels. Our reliable and professional taxi service ensures a smooth and enjoyable journey, whether it's a one-way trip or a round trip."
    },
    {
      "name": "Book Mumbai to Bangalore Taxi",
      "description": "Booking a taxi from Mumbai to Bangalore is quick and easy with S9 Travels. Enjoy a hassle-free ride in a well-maintained vehicle with a professional driver."
    },
    {
      "name": "Affordable Mumbai to Bangalore Cab",
      "description": "Looking for an affordable taxi from Mumbai to Bangalore? S9 Travels offers competitive pricing without compromising on the quality of service, ensuring you get the best value for your journey."
    },
    {
      "name": "Private Taxi for Bangalore from Mumbai",
      "description": "Book a private taxi for a personalized travel experience from Mumbai to Bangalore. Our private cabs offer comfort, convenience, and privacy for your long journey."
    },
    {
      "name": "Mumbai to Bangalore One-Way or Round Trip",
      "description": "Whether you're planning a one-way trip or a round trip, S9 Travels offers flexible taxi services for your journey from Mumbai to Bangalore. Choose the option that best suits your travel needs."
    },
    {
      "name": "Bangalore Trip by Cab from Mumbai",
      "description": "Explore Bangalore with ease by booking a cab from Mumbai. Our experienced drivers will take you to the city's key attractions, ensuring a pleasant trip throughout."
    },
    {
      "name": "Luxury Taxi from Mumbai to Bangalore",
      "description": "Travel in luxury from Mumbai to Bangalore with our premium taxi service. Enjoy a comfortable ride in a luxury vehicle, equipped with top-tier amenities for a high-end experience."
    },
    {
      "name": "Group Travel to Bangalore",
      "description": "Planning a group trip to Bangalore? S9 Travels offers spacious cabs that can comfortably accommodate your group, ensuring a comfortable and enjoyable ride for everyone."
    },
    {
      "name": "Comfortable Mumbai to Bangalore Cab Service",
      "description": "Experience comfort and convenience on your trip from Mumbai to Bangalore. Our well-maintained cabs and professional drivers ensure a smooth, stress-free journey."
    },
    {
      "name": "Bangalore Tour by Taxi from Mumbai",
      "description": "Book a taxi for a sightseeing tour of Bangalore from Mumbai. Our drivers will take you to the city's popular spots, providing you with a relaxing and enjoyable experience."
    }
],

"tableData": [
  ["Mumbai to Bangalore Cab Service", "Book Mumbai to Bangalore Taxi"],
  ["Affordable Mumbai to Bangalore Cab", "Private Taxi for Bangalore from Mumbai"],
  ["Mumbai to Bangalore One-Way or Round Trip", "Bangalore Trip by Cab from Mumbai"],
  ["Luxury Taxi from Mumbai to Bangalore", "Group Travel to Bangalore"],
  ["Comfortable Mumbai to Bangalore Cab Service", "Bangalore Tour by Taxi from Mumbai"],
  ["", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Long-Distance Comfort and Convenience",
    "WhyChoosedescription": "S9 Travels offers a comfortable Mumbai to Bangalore cab service, designed for long-distance travel. Our well-maintained vehicles, including the Toyota Innova, ensure a smooth and relaxing ride with ample space, air conditioning, and comfortable seating for a stress-free journey."
  },
  {
    "WhyChooseheading": "Timely and Reliable Service",
    "WhyChoosedescription": "When you book a Mumbai to Bangalore cab with S9 Travels, you can expect reliable and punctual service. We understand the importance of time, so our drivers ensure timely pick-ups and drop-offs, allowing you to stick to your travel schedule without any delays."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced professionals who are familiar with the best routes between Mumbai and Bangalore. They prioritize your safety and comfort, ensuring a smooth and efficient journey throughout the trip, no matter the distance or road conditions."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for the Mumbai to Bangalore cab service. We provide a transparent pricing structure with no hidden charges. You will receive a detailed breakdown of the costs during the booking process, making it easy to plan your budget."
  },
  {
    "WhyChooseheading": "Safety and Comfort Across Long Distances",
    "WhyChoosedescription": "Your safety is our priority. Our cabs are equipped with modern safety features, including GPS tracking, airbags, and seat belts, to ensure that your long-distance journey from Mumbai to Bangalore is as safe and comfortable as possible."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, so you can book your Mumbai to Bangalore cab at a time that suits you. Whether you need an early morning departure or a late-night ride, we offer flexible scheduling to accommodate your travel needs."
  },
  {
    "WhyChooseheading": "Customizable Travel Plans",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you want to take breaks along the way, have specific stops in mind, or need an adjusted itinerary, we offer customizable travel plans to make your Mumbai to Bangalore journey more enjoyable and tailored to your preferences."
  },
  {
    "WhyChooseheading": "Easy and Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a cab for your Mumbai to Bangalore trip is simple and hassle-free. You can book online through our website or app, or reach out to our customer service team for personalized assistance. We make the booking process quick, easy, and stress-free."
  }
]














    }


    const faqData = [
        [
          {
            question: 'How can I book a cab from Mumbai to Bangalore with S9 Travels?',
            answer: 'Booking a cab from Mumbai to Bangalore is easy! You can book your ride online via our website or mobile app, or contact our customer service team for assistance. We’ll ensure a comfortable and smooth long-distance journey.',
          },
          {
            question: 'What types of vehicles are available for Mumbai to Bangalore travel?',
            answer: 'We offer a range of vehicles for your long-distance journey from Mumbai to Bangalore, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the vehicle that suits your travel preferences and group size.',
          },
          {
            question: 'How long does the journey from Mumbai to Bangalore take?',
            answer: 'The journey from Mumbai to Bangalore typically takes around 16 to 18 hours, depending on road conditions and traffic. Our experienced drivers ensure a comfortable and safe journey with rest stops for meals and breaks.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel like Mumbai to Bangalore?',
            answer: 'Yes, all our drivers are highly experienced in long-distance travel and are well-versed with the best routes between Mumbai and Bangalore. They prioritize your safety and comfort throughout the journey.',
          },
          {
            question: 'Can I book a round trip for Mumbai to Bangalore?',
            answer: 'Yes, you can book a round-trip cab for your journey from Mumbai to Bangalore. Simply inform us of your return details, and we will ensure a timely and comfortable return trip.',
          },
          {
            question: 'Is there a fixed fare for Mumbai to Bangalore cab service?',
            answer: 'The fare for Mumbai to Bangalore cab service depends on the type of vehicle, trip duration, and any specific requirements you may have. Contact us for a customized quote and transparent pricing.',
          },
          {
            question: 'Do you provide pick-up services from Mumbai airport or hotels for Bangalore trips?',
            answer: 'Yes, we provide pick-up services from Mumbai airport or hotels for your trip to Bangalore. Our driver will ensure a smooth and timely pick-up and drop-off at your preferred location.',
          },
          {
            question: 'Can I request additional stops on the way to Bangalore?',
            answer: 'Yes, we can accommodate additional stops for meals, sightseeing, or breaks during your journey to Bangalore. Just let us know your preferences when booking, and we will customize the trip accordingly.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Mumbai to Bangalore trip?',
            answer: 'Any extra charges for waiting time or detours will be communicated upfront during the booking process. We ensure full transparency in pricing, with no hidden costs.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai to Bangalore cab service?',
            answer: 'S9 Travels offers reliable, safe, and comfortable cab services for long-distance travel. With well-maintained vehicles, professional drivers, and excellent customer service, we ensure a hassle-free and enjoyable experience for your Mumbai to Bangalore trip.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Karthik Kumar',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Mumbai to Bangalore with S9 Travels, and the experience was fantastic. The driver was professional and very knowledgeable about the route. The car was comfortable, and the long journey was made enjoyable. I highly recommend their service for long-distance travel!”',
        },
        {
          name: 'Mrs. Neha Sharma',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We traveled from Mumbai to Bangalore with S9 Travels, and it was a pleasant experience. The driver was courteous, the vehicle was in excellent condition, and the journey was smooth. We will definitely use S9 Travels for future long-distance trips!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai to Bangalore Cab",
        "description": "Book affordable and reliable Mumbai to Bangalore cab services for one-way trips, round trips, luxury cabs, and group travel. S9 Travels offers private taxi rides for a comfortable and scenic journey from Mumbai to Bangalore, ideal for vacations, business trips, and sightseeing tours.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
   
      


    return (
        <div>
        
        <Helmet>
        <title>Mumbai to Bangalore Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Mumbai to Bangalore taxi services, including one-way, round-trip, and luxury cabs. Comfortable and affordable transport for sightseeing tours, business travel, and vacations from Mumbai to Bangalore with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
     
      
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/60.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitobanglorecab;